import React from 'react'
import { Box, Text, Image } from 'pcln-design-system'
import styled from 'styled-components'

type ProductItemType = {
  imageUrl: string
  altText: string
  headline: string
  subheadline: string
}

const StyledImage = styled(Image)`
  object-fit: cover;
`

export default function ProductItem({
  imageUrl,
  altText,
  headline,
  subheadline
}: ProductItemType) {
  return (
    <Box>
      <StyledImage
        mb="24px"
        src={`${imageUrl}?opto&auto=avif,webp`}
        alt={altText}
        loading="lazy"
        height={['425px', null, null, null, null, '500px']}
      />
      <Text textStyle="heading6" pb={2} textAlign="center">
        {headline}
      </Text>
      <Text textStyle="paragraph" textAlign="center">
        {subheadline}
      </Text>
    </Box>
  )
}
